module.exports = Package['random'];